/**
 * Overview:
 * This component renders a loading skeleton for the dashboard.
 * It displays placeholder widget cards with animated loading effects
 * to improve the user experience while dashboard data is being fetched.
 */
const DashboardSkeleton = () => {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <div key={`${index}-skeleton`} className="bg-white rounded-xl border border-gray-200 p-4 animate-pulse">
          <div className="h-6 w-40 bg-gray-200 rounded mb-4" />

          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-4/6" />
          </div>
        </div>
      ))}
    </>
  );
};

export default DashboardSkeleton;
